module.exports = __webpack_public_path__ + "img/circle_white.17a9c262.png";